import React, {PureComponent} from "react"
import gql from "graphql-tag"
import {Query, QueryProps, QueryResult} from "react-apollo"

import {Query as QueryComponent} from "@irati/utils/services/apollo"

import {Reward} from "../../types"
import RewardCatalogueProduct from "./fragments/RewardCatalogueProduct"

const query = gql`
  query RewardCatalogueReward($rewardId: String) {
    rewardCatalogueReward(rewardId: $rewardId) {
      uuid
      archived
      internalIdentifier
      urlSlug
      status
      header
      description
      importantInfo
      deliveryInfo
      redemptionInstructions
      termsAndConditions
      bannerImage
      cardImage
      thumbnailImage
      keywords
      locale
      country
      isCredit
      products {
        count
        total
        results {
          ...RewardCatalogueProduct
        }
      }
      tags {
        uuid
        name
      }
    }
  }
  ${RewardCatalogueProduct}
`

const defaultProps = {
  query,
  useLoader: true
}

interface Variables {
  rewardId: string
}

interface Data {
  rewardCatalogueReward: Reward
}

export type RewardCatalogueQueryResponse = QueryResult<Data, Variables>

interface Props extends Partial<QueryProps<Data, Variables>> {
  query?: string
  useLoader?: boolean
}

class TypedQuery extends Query<Data, Variables> {}

export default class RewardCatalogueRewardQuery extends PureComponent<Props> {
  static defaultProps = defaultProps

  render() {
    return <QueryComponent {...this.props} Query={TypedQuery} />
  }
}
